import axios from '../axios/redditlikeApi'

const getAvatars = () => {
  return axios.get('/avatars')
}

const getDefaultAvatars = () => {
  return axios.get('/avatars/default')
}

const getAvatarById = id => {
  return axios.get(`/avatars/${id}`)
}

const createAvatar = form => {
  return axios.post('/avatars', form)
}

export default {
  getAvatars,
  getDefaultAvatars,
  getAvatarById,
  createAvatar
}
